import { CustomerIcon, Features, HomeIcon, MarketingIcon, OrdersIcon, Settngs } from '../assets/svgs';

import Customers from './DashboardPages/Customers.jsx';
import Home from './DashboardPages/Home';
import Orders from './DashboardPages/Orders.jsx';
import Settings from './DashboardPages/Settings.jsx';
import ThemeSelect from './DashboardPages/ThemeSelect';
import AddOrder from './DashboardPages/AddOrder';
import CustomerGroups from './DashboardPages/CustomerGroups';
import Campaigns from './DashboardPages/Campaigns';
import AddPopup from './DashboardPages/AddPopup';
import AddPhoneNoti from './DashboardPages/AddPhoneNoti';
import ManageApps from './DashboardPages/ManageApps';
import FeatureStore from './DashboardPages/FeatureStore';
import Help from './DashboardPages/Help';
import Profile from './Profile';
import Publish from './DashboardPages/Publish/Publish';
import Soon from './Soon';
import Notification from './DashboardPages/Notifications';
import Popups from './DashboardPages/Popups';
import Policies from './DashboardPages/Policies';

import {
  SVG_Tuning_Square_Outline,
  SVG_Widget_5_Outline,
  SVG_Translation_Outline,
  SVG_Shop_Minimalistic_Outline,
  SVG_Settings_Outline,
  SVG_Cart_Large_2_Linear,
  SVG_Users_Group_Rounded_Linear,
  SVG_Delivery_Linear,
  SVG_PIP_Linear,
  SVG_Lock_Password_Linear,
  SVG_Text_Field_Focus_Linear,
  SVG_Text_Square_Linear,
  SVG_Home_2_Linear,
  SVG_Pen_2_Linear,
  SVG_Send_Square_Linear,
  SVG_Diskette_Linear,
  SVG_File_Send_Linear,
  SVG_Card_Send_Linear,
  SVG_Smartphone_Linear,
  SVG_Gallery_Add_Linear,
  SVG_Settings_Linear,
  SVG_Pulse_Linear,
  SVG_Widget_Add_Linear,
  SVG_Money_Bag_Linear,
  SVG_Hand_Money_Linear,
  SVG_Translation_Linear,
  SVG_Clipboard_Linear,
  SVG_Document_Broken,
} from '@dev-mobligo/iconpack';
import AgeRestrictions from './DashboardPages/AgeRestrictions';
import AbondonedCartNotification from './DashboardPages/AbondonedCartNotification';
import AbondonedCart from './DashboardPages/AbondonedCart';
import LanguageAndRegions from './DashboardPages/LanguageAndRegions';
import AddLanguage from './DashboardPages/AddLanguage';
import ThemeVariants from './DashboardPages/ThemeVariants';
import Staff from './DashboardPages/Staff';
import IntegrationsFirebase from './DashboardPages/Integrations/IntegrationsFirebase';
import IntegrationsProvider from './DashboardPages/Integrations/IntegrationsProvider';
import Billing from './DashboardPages/Payment/Billing';
import { faMoneyBill } from '@fortawesome/free-solid-svg-icons';
import LicenseDetails from './DashboardPages/License/LicenseDetails';
import LicensePurchase from './DashboardPages/License/LicensePurchase';
import SmartBanner from './DashboardPages/SmartBanner';
import { QrCodeIcon } from '@heroicons/react/24/outline';
import SmartBannerIcon from '../assets/svgs/smartbanner';
import DynamicQR from './DashboardPages/DynamicQR';
import PublishTable from './DashboardPages/Publish/PublishTable';
import StoreSettings from './DashboardPages/StoreSettings';
const tabs = [
  {
    title: 'Giriş',
    icon: {
      component: SVG_Home_2_Linear,
      classNames: 'stroke-[#5E5873]',
    },
    pointTo: '/dashboard/',
    subTabs: [],
    component: Home,
  },
  {
    title: 'Tema Düzenle',
    icon: {
      component: SVG_Pen_2_Linear,
      classNames: 'stroke-[#5E5873]',
    },
    pointTo: '/dashboard/theme',
    subTabs: [],
    component: ThemeSelect,
  },
  {
    title: 'Yayınla',
    icon: {
      component: SVG_Smartphone_Linear,
      classNames: 'stroke-[#5E5873]',
    },
    pointTo: '/dashboard/publish',
    subTabs: [],
    component: PublishTable,
  },
  {
    title: 'Otomasyonlar',
    icon: {
      component: SVG_Diskette_Linear,
      classNames: 'stroke-[#5E5873]',
    },
    pointTo: '/dashboard/otomations',
    subTabs: [
      {
        title: 'Sepet Hatırlatma Bildirimleri',
        icon: {
          component: SVG_Cart_Large_2_Linear,
          classNames: 'stroke-[#5E5873]',
        },
        pointTo: '/dashboard/otomations/abondoned-cart',
        subTabs: [],
        component: AbondonedCart,
      },
      {
        isDisabled: true,
        title: 'Tekrar Stokta',
        icon: {
          component: SVG_Delivery_Linear,
          classNames: 'stroke-[#5E5873]',
        },
        pointTo: '/dashboard/otomations',
        subTabs: [],
        component: Soon,
      },
    ],
    component: Soon,
  },
  {
    title: 'Pazarlama',
    icon: {
      component: SVG_Hand_Money_Linear,
      classNames: 'stroke-[#5E5873]',
    },
    pointTo: '/dashboard/marketing/',
    subTabs: [
      {
        title: 'Bildirimler',
        pointTo: '/dashboard/marketing/notification',
        component: Notification,
        icon: {
          component: MarketingIcon,
          classNames: 'stroke-[#5E5873]',
        },
        subTabs: [],
      },
      // {
      //   title: 'Pop-up',
      //   pointTo: '/dashboard/marketing/pop-up',
      //   component: Popups,
      //   icon: {
      //     component: SVG_PIP_Linear,
      //     classNames: 'stroke-[#5E5873]',
      //   },
      //   subTabs: [
      //     {
      //       title: 'Popup Ekle',
      //       icon: {
      //         component: Settngs,
      //         classNames: 'stroke-[#5E5873]',
      //       },
      //       pointTo: '/dashboard/marketing/pop-up/add-popup',
      //       subTabs: [],
      //       component: AddPopup,
      //     },
      //   ],
      // },
    ],
    component: null,
  },
  {
    title: 'Eklentiler',
    icon: {
      component: SVG_Widget_Add_Linear,
      classNames: 'stroke-[#5E5873]',
    },
    pointTo: '/dashboard/addons/',
    subTabs: [
      {
        title: 'Smart Banner',
        pointTo: '/dashboard/addons/smart-banner',
        component: SmartBanner,
        icon: {
          component: SmartBannerIcon,
          classNames: 'stroke-[#5E5873]',
        },
        subTabs: [],
      },
      {
        title: 'Dinamik QR',
        pointTo: '/dashboard/addons/dynamic-qr',
        component: DynamicQR,
        icon: {
          component: QrCodeIcon,
          classNames: 'stroke-[#5E5873] p-4',
        },
        subTabs: [],
      },
      {
        title: 'App Badge',
        pointTo: '/dashboard/addons/app-badge',
        component: Soon,
        isDisabled: true,
        icon: {
          component: MarketingIcon,
          classNames: 'stroke-[#5E5873]',
        },
        subTabs: [],
      },
    ],
    component: FeatureStore,
  },
  {
    title: 'Ayarlar',
    icon: {
      component: SVG_Settings_Linear,
      classNames: 'stroke-[#5E5873]',
    },
    pointTo: '/dashboard/theme-settings',
    subTabs: [
      {
        title: '+18 Kategori Filtresi',
        icon: {
          component: SVG_Lock_Password_Linear,
          classNames: 'stroke-[#5E5873]',
        },
        pointTo: '/dashboard/theme-settings/age-restrictions',
        subTabs: [],
        component: AgeRestrictions,
      },
      {
        title: 'Sözleşmeler',
        icon: {
          component: SVG_Users_Group_Rounded_Linear,
          classNames: 'stroke-[#5E5873]',
        },
        pointTo: '/dashboard/theme-settings/policies',
        subTabs: [],
        component: Policies,
      },
      {
        title: 'Lokalizasyon Ayarları',
        icon: {
          component: SVG_Text_Square_Linear,
          classNames: 'stroke-[#5E5873]',
        },
        pointTo: '/dashboard/theme-settings/language-and-regions',
        subTabs: [],
        component: LanguageAndRegions,
      },
      {
        title: 'Dil ve Çeviriler',
        icon: {
          component: SVG_Text_Square_Linear,
          classNames: 'stroke-[#5E5873]',
        },
        pointTo: '/dashboard/language-settings/theme-variants',
        subTabs: [],
        component: ThemeVariants,
      },
      {
        title: 'Personel Ayarları',
        icon: {
          component: SVG_Users_Group_Rounded_Linear,
          classNames: 'stroke-[#5E5873]',
        },
        pointTo: '/dashboard/theme-settings/staff',
        subTabs: [],
        component: Staff,
      },
      {
        title: 'Entegrasyonlar',
        icon: {
          component: SVG_Translation_Linear,
          classNames: 'stroke-[#5E5873]',
        },
        pointTo: '/dashboard/theme-settings/integrations',
        grid: true,
        subTabs: [
          {
            title: 'Alt Yapı',
            icon: {
              component: SVG_Translation_Linear,
              classNames: 'stroke-[#5E5873]',
            },
            pointTo: '/dashboard/theme-settings/integrations/provider',
            subTabs: [],
            component: IntegrationsProvider,
          },
          {
            title: 'Firebase',
            icon: {
              component: SVG_Translation_Linear,
              classNames: 'stroke-[#5E5873]',
            },
            pointTo: '/dashboard/theme-settings/integrations/firebase',
            subTabs: [],
            component: IntegrationsFirebase,
          },
        ],
        component: () => <></>,
      },
      {
        title: 'Fatura Bilgileri',
        icon: {
          component: SVG_Clipboard_Linear,
          classNames: 'stroke-[#5E5873]',
        },
        pointTo: '/dashboard/theme-settings/billing-information',
        subTabs: [],
        component: Billing,
      },
      {
        isDisabled: false,
        title: 'Lisans Detayları',
        icon: {
          component: SVG_Clipboard_Linear,
          classNames: 'stroke-[#5E5873]',
        },
        pointTo: '/dashboard/theme-settings/license-details',
        subTabs: [
          {
            title: 'Planı Yükselt',
            icon: {
              component: SVG_Clipboard_Linear,
              classNames: 'stroke-[#5E5873]',
            },
            pointTo: '/dashboard/theme-settings/license-details/purchase',
            subTabs: [],
            component: LicensePurchase,
          },
        ],
        component: LicenseDetails,
      },
      {
        isDisabled: false,
        title: 'Mağaza Ayarları',
        icon: {
          component: SVG_Clipboard_Linear,
          classNames: 'stroke-[#5E5873]',
        },
        pointTo: '/dashboard/theme-settings/store-settings',
        subTabs: [],
        component: StoreSettings,
      },
    ],
    component: null,
  },
];

// const sales_channels = [
//   // {
//   //   isDisabled: false,
//   //   title: 'Mobil Uygulama',
//   //   icon: {
//   //     component: SVG_Shop_Minimalistic_Outline,
//   //     classNames: 'stroke-[#5E5873] fill-[#5E5873] p-[3px]',
//   //   },
//   //   pointTo: '/dashboard/theme/',
//   //   subTabs: [
//   //     {
//   //       title: 'Tema Düzenle',
//   //       pointTo: '/dashboard/theme/',
//   //       component: ThemeSelect,
//   //       icon: {
//   //         component: SVG_Widget_5_Outline,
//   //         classNames: 'stroke-[#5E5873] fill-[#5E5873]',
//   //       },
//   //     },
//   //     {
//   //       title: 'Uygulama Ayarları',
//   //       pointTo: '/dashboard/theme/app-settings/',
//   //       component: ManageApps,
//   //       icon: {
//   //         component: SVG_Tuning_Square_Outline,
//   //         classNames: 'stroke-[#5E5873] fill-[#5E5873]',
//   //       },
//   //       subTabs: [],
//   //       isDisabled: true,
//   //     },
//   //     {
//   //       title: 'Yayınla',
//   //       pointTo: '/dashboard/theme/publish/',
//   //       component: Publish,
//   //       icon: {
//   //         component: SVG_Translation_Outline,
//   //         classNames: 'stroke-[#5E5873] fill-[#5E5873]  p-[0px]',
//   //       },
//   //     },
//   //     {
//   //       title: 'Ayarlar',
//   //       pointTo: '/dashboard/theme/theme-settings/',
//   //       component: Policies,
//   //       icon: {
//   //         component: SVG_Settings_Outline,
//   //         classNames: 'stroke-[#5E5873] fill-[#5E5873]  p-[0px]',
//   //       },
//   //     },

//   //   ],
//   //   component: ThemeSelect,
//   // },

// ];

// const bottom_tabs = [
//   // {
//   //   title: 'Ayarlar',
//   //   icon: {
//   //     component: Settngs,
//   //     classNames: 'stroke-[#5E5873]',
//   //   },
//   //   pointTo: '/dashboard/settings',
//   //   subTabs: [],
//   //   component: Settings,
//   // },
// ];

//@ts-ignore
const hiddenTabs = [
  // {
  //   isHidden: true,
  //   title: 'Profil',
  //   icon: {
  //     component: Settngs,
  //     classNames: 'stroke-[#5E5873]',
  //   },
  //   pointTo: '/dashboard/profile',
  //   subTabs: [],
  //   component: Profile,
  // },
  // {
  //   isHidden: true,
  //   title: 'Yardım',
  //   icon: {
  //     component: Settngs,
  //     classNames: 'stroke-[#5E5873]',
  //   },
  //   pointTo: '/dashboard/help',
  //   subTabs: [],
  //   component: Help,
  // },
  // {
  //   isHidden: true,
  //   title: 'Soon',
  //   icon: {
  //     component: Settngs,
  //     classNames: 'stroke-[#5E5873]',
  //   },
  //   pointTo: '/dashboard/soon',
  //   subTabs: [],
  //   component: Soon,
  // },
  // {
  //   isHidden: true,
  //   title: 'Şifreyi Değiştir',
  //   icon: {
  //     component: Settngs,
  //     classNames: 'stroke-[#5E5873]',
  //   },
  //   pointTo: '/dashboard/change-password',
  //   subTabs: [],
  //   component: Soon,
  // },
];

const tabFlattener = (tabs: any, i: string = '', activeTabs: string[] = [], activeTabTitles: string[] = []) => {
  return tabs.reduce((acc: any, tab: any, index: number) => {
    acc.push({
      ...tab,
      id: i + index,
      activeTabs: [...activeTabs, i + index],
      activeTabTitles: [...activeTabTitles, tab.title],
    });
    if (tab.subTabs) {
      acc.push(
        ...tabFlattener(tab.subTabs, i + index + '_', [...activeTabs, i + index], [...activeTabTitles, tab.title]),
      );
    }
    return acc;
  }, []);
};

const allTabs = [
  //@ts-ignore
  ...tabFlattener([...tabs, ...hiddenTabs]),
  // ...tabFlattener(bottom_tabs),
  // ...tabFlattener(sales_channels),
];
//@ts-ignore
export { tabs };
export default allTabs;
